import { BUTTON_HEIGHT, FONT_SIZE, TEXT_SCALE_PROPS } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";

export const DragHandleButton = styled.div`
  background-color: #1890ff;
  color: white;
  padding: 4px 8px;
  text-align: center;
  cursor: move;
  border-radius: 4px 0 0 4px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Styles = styled.div<TEXT_SCALE_PROPS>`
  padding-top: 10px;

  .container {
    padding-bottom: 20px;

    .status {
      font-weight: 600;
      font-size: ${({ text_scale }) =>
        FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
    }
    .extract-column {
      font-weight: 300;
      font-size: ${({ text_scale }) =>
        FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
    }

    .ant-checkbox-inner {
      border: 1px solid #292929;
    }

    .headerBar {
      padding: 5px 15px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #0000000d;

      .caret {
        display: flex;
        align-items: center;
      }
    }

    .tableWrapper {
      padding-top: 8px;

      ant-table-content {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        margin-bottom: 40px;
      }
      .ant-table-row-expand-icon {
        display: none;
      }

      [data-row-key^="rowAsHeader_"] {
        /* css header */
        background-color: #eeeeee !important;
      }
      .ant-table-row {
        background-color: #f9f9f9;
      }

      th.ant-table-cell {
        background-color: #f2f2f2;
        border: 1px solid #fff;
        padding: 0px 16px !important;
        height: ${({ text_scale }) =>
          `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
        font-size: ${({ text_scale }) =>
          FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
      }

      td.ant-table-cell {
        background-color: #f2f2f2;
        border: 1px solid #fff;
        padding: 0px 16px !important;
        height: ${({ text_scale }) =>
          `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
        font-size: ${({ text_scale }) =>
          FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
      }

      .min-width-80px {
        min-width: 80px;
      }

      .delete-tag {
        min-width: 80px;

        &.restore {
          background-color: #fec30a;
        }
      }

      .disabled-tag {
        background-color: #cdcdcd !important;
        cursor: not-allowed !important;
      }

      .save-item {
        border: 1px solid #d9d9d9;
        background-color: #f5f5f5;
        color: #00000040;
        min-width: 50%;
        padding: 2px 8px;
        margin: 0 3px;
        text-align: center;
        cursor: pointer;

        &.draft,
        &.save {
          background-color: #0e54d0;
          color: white;
        }
      }

      .btn-create {
        height: 40px;
        min-width: 120px;
      }

      .custom-btn-category-status {
        min-width: 90px;
        height: 40px;
        font-size: 14px;
      }

      .ant-btn-primary[disabled],
      .ant-btn-primary[disabled]:hover,
      .ant-btn-primary[disabled]:focus,
      .ant-btn-primary[disabled]:active {
        border: 1px solid #fff;
      }

      input:disabled,
      .ant-input[disabled] {
        background-color: #f5f5f5;
      }

      .deleted-record {
        text-decoration: line-through;
      }
    }

    .ant-collapse-expand-icon {
      .btn-collapse {
        font-size: ${({ text_scale }) =>
          FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
        height: ${({ text_scale }) =>
          `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
        padding: 0px 5px;
        display: flex;
        align-items: center;
      }
    }
  }
  .ant-input {
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL] - 3}px`} !important;
  }
  .ant-checkbox + span {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
  }
  .ant-checkbox-inner {
    width: ${({ text_scale }) =>
      `${
        BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL] -
        (text_scale === DISPLAY_SIZES.LARGE
          ? 9
          : text_scale === DISPLAY_SIZES.MEDIUM
          ? 6
          : 3)
      }px`} !important;

    height: ${({ text_scale }) =>
      `${
        BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL] -
        (text_scale === DISPLAY_SIZES.LARGE
          ? 9
          : text_scale === DISPLAY_SIZES.MEDIUM
          ? 6
          : 3)
      }px`} !important;
  }
`;
